import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware } from 'redux';
import { loadState, saveState } from './localStorage';
import rootReducer from '../redux';
import { initialState as pushMessagesInitialState } from '../redux/pushMessages/reducer';
import { pickPersistedState, mergePersistedState } from './persistence';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';


export const history = createBrowserHistory();

const middlewares = [
  thunkMiddleware,
];
const composeEnhancers = composeWithDevTools({
  trace: process.env.NODE_ENV === 'development',
  traceLimit: 25
});
// what is persisted, and how it is merged back over the reducers' initial
// shapes: services/persistence.js
const persistedState = mergePersistedState(loadState(), pushMessagesInitialState);
const store = createStore(rootReducer, persistedState, composeEnhancers(applyMiddleware(...middlewares)));

store.subscribe(() => {
  saveState(pickPersistedState(store.getState()));
});

import('./firebase').then(() => {
  const { verifyAuth } = require('../redux/auth/actions');
  store.dispatch(verifyAuth());
});

export default store;
